/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const tooltipPositions = {
  TOP: 'top' as const,
  BOTTOM: 'bottom' as const,
  RIGHT: 'right' as const,
  LEFT: 'left' as const,
  TOP_START: 'top-start' as const,
  TOP_END: 'top-end' as const,
  BOTTOM_START: 'bottom-start' as const,
  BOTTOM_END: 'bottom-end' as const,
  RIGHT_START: 'right-start' as const,
  RIGHT_END: 'right-end' as const,
  LEFT_START: 'left-start' as const,
  LEFT_END: 'left-end' as const,
};

export { tooltipPositions };
